<template>
    <v-main>
        <v-container fluid  text-xs-center>
            <v-card>
                <v-card-title>
                    <v-btn outlined @click="getbycode()">Check For More</v-btn>
                    <v-spacer></v-spacer>
                    <v-select :items="codes"
                              outlined
                              dense
                              Label="select Code"
                              item-text="code"
                              item-value="code" @change="getbycode()" v-model="code"></v-select>
                </v-card-title>
                <v-card-text>
                    <template>
                        <v-data-table
                                :headers="headers"
                                :items="invoices"
                                :items-per-page="100"
                                fixed-header
                        >
                            <template v-slot:item.name="{ item }">
                                <v-btn small outlined text @click="getContact(item)">{{item.name}}</v-btn>
                            </template>
                            <template v-slot:item.status="{ item }">
                                <v-chip :color="getColor(item)" dark>{{ item.status }}</v-chip>
                            </template>
                            <template v-slot:item.invoiceId="{ item } ">
                                <a :href='`https://www.paypal.com/invoice/p/#${item.invoiceId}`' target="_blank">View</a>
                            </template>
                            <template v-slot:item.data="{ item }">
                                {{item.data.items[0].name}}
                            </template>
                            <template v-slot:item.text="{ item }">
                                <v-btn :disabled="item.paid===1 || ['cancelled','draft'].includes(item.status)" :color="item.textedon?'':'info'" outlined small @click="textNotify(item.invoiceId)">TXT</v-btn>
                            </template>
                            <template v-slot:item.textedon="{ item }">
                                <span v-if="item.textedon">{{ new Date(parseInt(item.textedon)).toDateString()}}</span>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn outlined x-small v-if="!item.paid && ['cancelled','draft'].includes(item.status)" @click="Delete(item)">Delete</v-btn>
                                <v-btn outlined x-small v-if="!item.paid && item.status=='sent'" @click="confirmMarkPaid(item)">Mark Paid</v-btn>
                                <v-btn outlined x-small v-if="(!item.paid && item.status=='sent') || item.status==='draft'" @click="confirmCancel(item)">Cancel</v-btn>
                                <v-btn outlined :loading="reminding===item.invoiceId" x-small v-if="!item.paid && item.status=='sent'" @click="remind(item.invoiceId)">Remind</v-btn>
                                <v-btn outlined x-small v-if="!item.paid && item.status=='draft'" @click="send(item.invoiceId)" :loading="sending===item.invoiceId">
                                    Send
                                </v-btn>
                                <v-btn text small disabled v-if="item.paid">paid</v-btn>
                            </template>
                            <template v-slot:item.reminded="{ item }">
                                <span v-if="item.reminded">{{ new Date(parseInt(item.reminded)).toDateString()}}</span>
                            </template>
                        </v-data-table>
                    </template>
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined @click="newinvoicedialog=true">New</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="sendtextreminder()">Text Remind All</v-btn>
                </v-card-actions>
            </v-card>

            <v-dialog v-model="newitemdialog" max-width="500">
                <v-card>
                    <v-card-title>
                        Add Invoice Item
                    </v-card-title>
                    <v-card-text>
                        <v-layout rwo wrap>
                            <v-flex xs12 sm12 md12>
                                <v-text-field
                                        label="Item name"
                                        placeholder="Add Item Name"
                                        outlined
                                        v-model="newitem.name"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-text-field
                                        label="Item Quantity"
                                        placeholder="Add Item Quantity"
                                        outlined
                                        v-model="newitem.quantity"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-text-field
                                        label="Item Price"
                                        placeholder="Add Item Price"
                                        outlined
                                        v-model="newitem.unit_price.value"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-text-field
                                        label="Code"
                                        outlined
                                        :readonly="codero"
                                        :value="code"
                                        :append-outer-icon="(codero)?icons.edit:icons.done"
                                        @click:append-outer="codero=!codero"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn small outlined @click="newitemdialog=false">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn small outlined @click="addItem">Add Item</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="newinvoicedialog" max-width="500">
                <v-card>
                    <v-card-title>
                        New Invoice for {{customer.name}}
                    </v-card-title>
                    <v-card-text>
                        <v-flex xs12 v-if="!customer">
                            <v-text-field
                                    label="Search contacts by  Name, Email or Cell"
                                    outlined
                                    v-model="searchcontacts"
                                    @keyup="searchContacts(searchcontacts)"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 v-else>
                            <v-list v-if="items.length>0">
                                <v-list-item v-for="(t,i) in items" :key="i" >
                                    <v-list-item-content >
                                        <v-list-item-title>
                                            {{t.name}} @ {{t.quantity}}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            ${{t.unit_price.value}}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn icon @click="removeItem(i)">
                                            <v-icon>{{icons.delete}}</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                            <v-btn v-else outlined small :disabled="!customer" @click="newitemdialog=true">Add Item</v-btn>
                        </v-flex>

                    </v-card-text>

                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex xs12 v-for="(s,i) in searchresults" @click="setCustomer(s)">
                                <v-btn outlined block  small><v-icon>{{icons.plus}}</v-icon>{{s.name}} | {{s.email}} </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn outlined small :disabled="!customer" @click="newItem()">Add Item</v-btn>
                        <v-btn outlined small @click="clear()">Clear</v-btn>
                        <v-btn outlined small @click="newinvoicedialog=false, clear()">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn outlined small @click="create" :loading="loading">Create</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="confirmmarkpaiddialog" max-width="600">
                <v-card>
                    <v-card-title>Mark {{activeinvoice.invoiceId}} as Paid</v-card-title>
                    <v-card-text>
                        Invoice to {{activeinvoice.name}}
                        <div v-for="t in invoicedata.items" >{{t.name+' '+t.quantity+' @ '+t.unit_price.value}}</div>
                        <v-text-field
                                label="Item name"
                                placeholder="Explain"
                                outlined
                                v-model="activeinvoice.note"
                        ></v-text-field>
                        <span class="red--text">{{paiderror}}</span>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text @click="clearActiveInvoice(),confirmmarkpaiddialog=false">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn text @click="markPaid()" :loading="loading">Mark Paid</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="confirmcanceldialog" max-width="600">
                <v-card>
                    <v-card-title>
                        Cancel {{activeinvoice.invoiceId}}
                    </v-card-title>
                    <v-card-text>
                        Confirm cancel invoice {{activeinvoice.invoiceId}}
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text @click="confirmcanceldialog = false, loading=false" >No (Close)</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn text @click="cancel()" :loading="loading">Yes, Cancel Invoice</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </v-main>
</template>

<script>
  import {
      mapState,
      mapActions
  } from 'vuex';
  export default {
    data () {
      return {
        invoices:[],
        code:'ALL',
        codes:[],
        activeinvoice:{
          data:'',
          invoiceId:''
        },
        invoicedata:{},
        paiderror:'',
        confirmmarkpaiddialog:false,
        headers: [
          { text: 'Parent', value: 'name' },
          { text: 'Status', value: 'status' },
          { text: 'Invoice', value: 'invoiceId'},
          { text: 'Items', value: 'data'},
          { text: 'TXT', value: 'text' },
          { text: 'Text On', value: 'textedon'},
          { text: 'Actions', value: 'actions' },
          { text: 'Reminder Sent', value: 'reminded' }
        ],
        payerview:'https://www.paypal.com/invoice/payerView/details/',
        newitem:{
          "name": "",
          "quantity": 0,
          "unit_price": {
            "currency": "USD",
            "value": 0
          }},
        items:[],
        newitemdialog:false,
        newinvoicedialog:false,
        searchresults:'',
        searchcontacts:'',
        customer:'',
        loading:undefined,
        markingpaid:'',
        reminding: false,
        confirmcanceldialog:false,
        codero:true,
        sending: false
      }
    },
    computed:{
      ...mapState(['icons'])
    },
    mounted(){
      this.getcode()
      this.getbycode()
    },
    methods:{
      ...mapActions(['get','post','delete','getActiveContact']),
      async getcode(){
        let response = await this.get({path: 'api/invoicing/getcodes'})
        this.codes = response
        this.codes.unshift('ALL')
      },
      async getbycode(){
        let response = await this.get({path:'api/invoicing/getinvoices/'+this.code})
        this.invoices=response.data
      },
      async remind(inv){
        let data = {
          orgpartkey:'volleyforlife',
          invoiceId:inv
        }//1604949009104
        this.reminding=inv;
        let response = await this.post({path:'api/invoicing/remind',body:data})
        let index = this.invoices.findIndex(f=>{return f.invoiceId===inv})
        this.invoices[index].reminded=response.reminded
        this.reminding=undefined
      },
      confirmMarkPaid(invoicedata){
        this.activeinvoice = invoicedata;
        console.log(invoicedata)
        this.invoicedata = this.activeinvoice.data
        this.confirmmarkpaiddialog = true;
      },
      async markPaid(){
        let data = {
          invoiceId:this.activeinvoice.invoiceId,
          note:this.activeinvoice.note
        }
        this.loading=true
        let response = await this.post({path:'api/invoicing/markpaid',body:data})
        this.loading=false
        if(response.error){
          this.paiderror = response.error
        } else {
          if(response.httpStatusCode===204){
            for(let i=0;i<this.invoices.length;i++){
              if(this.invoices[i].invoiceId===this.activeinvoice.invoiceId){
                this.invoices[i].paid=1
              }
            }
            this.confirmmarkpaiddialog = false
          }
        }
      },
      confirmCancel(invoicedata){
        this.activeinvoice = invoicedata;
        this.invoicedata = this.activeinvoice.data
        this.confirmcanceldialog = true;
      },
      async cancel(){
        this.loading = true
        let data = {
          invoiceId: this.activeinvoice.invoiceId
        }
        let response = await this.post({path:'api/invoicing/cancel',body:data})
        this.loading=false
        if(response.error){
          this.paiderror = response.error
        } else {
          if(response.httpStatusCode==204){
            let invs = this.invoices;
            for(let i=0;i<invs.length;i++){
              if(invs[i].invoiceId === this.activeinvoice.invoiceId){
                invs[i].status = 'cancelled'
              }
            }
            this.invoices = invs
          }
        }
        this.confirmcanceldialog = false;
      },
      async Delete(item){
        this.loading = true
        let data = {
          invoiceId:item.invoiceId
        }
        let response = await this.delete({path:'api/invoicing/delete',body:data})
        if(response.error){
          this.paiderror = response.error
          return
        }
        this.loading = false
        let t = this.invoices.filter(f=>{return f.invoiceId!=item.invoiceId})
        this.invoices = t
      },
      saveItem(item,i){
        this.items[i]=item;
        this.newitemdialog = false;
      },
      removeItem(i){
        this.items.splice(i,1)
      },
      addItem(){
        this.items.push(this.newitem);
        this.newitem={
          "name": "",
          "quantity": 0,
          "unit_price": {
            "currency": "USD",
            "value": 0
          }
        }
        this.newitemdialog = false;
        this.codero=false
      },
      newItem(){
        this.newitem={
          "name": "",
          "quantity": 0,
          "unit_price": {
            "currency": "USD",
            "value": 0
          }
        },
        this.newitemdialog = true;
        this.codero=false
      },
      editItem(item,i){
        this.newitem=item
        this.newitem.index = i
        this.newitemdialog = true;
      },
      async create(){
        let data = {
          items:this.items,
          customer:this.customer,
          code:this.code
        }
        let r = await this.post({path:'api/invoicing/create',body:data})
        console.log(r)
        this.loading=false
        this.newinvoicedialog=false
        this.items=[];
        this.customer='';
        this.getbycode()
      },
      async send(inv){
        this.sending = inv
        let data = {
          invoiceId:inv,
        }
        let response = await this.post({path:'api/invoicing/send',body:data})
        this.sending=false
        if(response.httpStatusCode===202){
          let tmp = []
          Object.assign(tmp,this.invoices)
          let index = this.invoices.findIndex(function(f){return f.invoiceId === inv})
          tmp[index].status = 'sent'
          this.invoices = tmp
        }
      },
      async searchContacts(str) {
        let data = {
          str: str
        };
        this.searchresults = await  this.post({path:'api/invoicing/searchcontact',body:data})
      },
      setCustomer(s){
        this.customer=s;
        this.searchresults='';
        this.searchcontacts='';
      },
      clear(){
        this.customer=''
        this.searchresults='';
        this.searchcontacts='';
        this.items=[];
        this.newitem={
          "name": "",
          "quantity": 0,
          "unit_price": {
            "currency": "USD",
            "value": 0
          }
        }
      },
      clearActiveInvoice(){
        this.activeinvoice = {
          data:'',
          invoiceId:''
        }
      },
      dt(d){
        if(!d)return'';
        let arr = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
        let date = new Date(parseInt(d))
        let m = date.getMonth()
        let month = arr[m]
        let day = date.getDate()
        let yr = date.getFullYear()
        return month + ' ' + day + ', '+yr
      },
      async sendtextreminder(){
        return
        //remindAll -- Not Connected yet
        let data = {
          orgpartkey:'volleyforlife',
          code:this.code,
        }
        let response = await this.post({path:'api/invoicing/sendnotification',body:data})
        console.log(this.response)
      },
      async textNotify(inv){
        //sends to ONE customer/contact
        let data = {
          code:this.code,
          invoiceid:inv
        }
        let response = await this.post({path:'api/invoicing/textnotify',body:data})
        if(response.httpStatusCode===202){
          let index = this.invoices.findIndex(function(f){return f.invoiceId === inv})
          let tmpinvoice = this.invoices[index]
          tmpinvoice.textedon = response.textedon
          Object.assign(this.invoices[index], this.editedItem)
        }
      },
      getColor (item) {
        let st = item.status;
        let pd = item.paid
        if (st ==='paid' || pd === 1) { item.status = 'paid'; return 'green darken-2' }
        else if (st === 'sent') return 'red'
        else if (st === 'cancelled') return 'blue-grey lighten-4'
        else return 'orange'
      },
      getDate(dt){
        if(!dt) return ' '
        let d = new Date(dt);
      },
      getContact(item){
        this.getActiveContact(item.uuid)
        this.$router.push('/contacts/edit/'+item.uuid)
      }
    }
  }
</script>

